import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { GetNotifications, GetToastNotifications } from '~/constants/getters';
import { ReadAllNotifications, RemoveAllNotifications, RemoveAllToasts, RemoveToastById } from '~/constants/mutations';

export default () => {
  const store = useStore();
  const realtime = inject('realtime');

  const notifications = computed(() => store.getters[`notificationStore/${GetNotifications}`]);
  const unreadNotifications = computed(() => store.getters[`notificationStore/${GetNotifications}`].filter(({ isRead }) => !isRead));
  const toasts = computed(() => store.getters[`notificationStore/${GetToastNotifications}`]);

  const markAllAsRead = (ids) => {
    realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'read',
      message: { ids },
    });
    store.dispatch(`notificationStore/${ReadAllNotifications}`);
  };

  const removeAllNotifications = () => {
    realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'clear',
      message: {},
    });
    store.commit(`notificationStore/${RemoveAllNotifications}`);
  };

  const removeAllToasts = () => {
    store.commit(`notificationStore/${RemoveAllToasts}`);
  };

  const removeToastById = (id) => {
    store.commit(`notificationStore/${RemoveToastById}`, id);
  };

  return {
    markAllAsRead,
    notifications,
    unreadNotifications,
    removeAllNotifications,
    toasts,
    removeAllToasts,
    removeToastById,
  };
};
